import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  const login = JSON.parse(localStorage.getItem("authenticated"))
    ? JSON.parse(localStorage.getItem("authenticated"))
    : false;

  return login !== false ? (
    <Outlet />
  ) : (
    <Navigate exact to={`${process.env.PUBLIC_URL}/login`} />
  );

  //return <Outlet />;
};
export default PrivateRoute;
